.SwitchboardContainer {
    width: 640px;
    height: 695px;
    position: relative;
}

.SwitchboardContainer.ScaledDown {
}

.SwitchboardBack {
    width: 640px;
    position: absolute;
    top: 0;
    left: 0;
}

.PlugGrid {
    position: absolute;
    z-index: 2;
    width: 566px;
    height: 437px;
    top: 150px;
    left: 38px;
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    user-select: none;
}

.PlugJackContainer {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding-top: 48px;
}

.PlugJackName {
    font-family: "Special Elite", system-ui;
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
}

.PlugHeadsContainer {
    position: absolute;
    top: 0;
    left: 0;
    width: 800px;
    height: 800px;
    z-index: 4;
}

.PlugHeadOneBase {
    top: 650px;
    left: 100px;
}

.PlugHeadTwoBase {
    top: 650px;
    left: 500px;
}

.PlugHead {
    position: absolute;
    height: 100px;
    width: 140px;
    z-index: 4;
}

.PlugHorizontalSection {
    display: flex;
    align-items: center;
    height: 50%;
    width: 100%;
}

.PlugHeadImage {
    height: 75%;
    width: 75%;
    clip-path: inset(0 0 0 50%);
    transition:
        clip-path 60ms linear,
        transform 60ms linear;
}
[aria-grabbed="true"] .PlugHeadImage {
    clip-path: inset(0 0 0 0);
    transform: translateX(10px);
}

.PlugWireHorizontal {
    width: 100%;
    height: 25%;
    background-color: black;
}

.PlugWireVertical {
    position: absolute;
    top: 25%;
    right: 0;
    width: 12%;
    height: 100%;
    background-color: black;
}

.cablesCanvas {
    position: absolute;
    width: 200%;
    height: 200%;
    transform: translate(-25%, -25%);
}
